import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, Mail, Phone, Heart, ChevronRight } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';
const Footer = () => {
  return <footer className="bg-[#3D52A0] text-white py-16 px-6 md:px-12 lg:px-24 relative overflow-hidden" data-id="element-16">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-17">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }} data-id="element-18"></div>
      </div>
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-19">
        <ScrollReveal data-id="element-20">
          <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-21">
            <div data-id="element-22">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sXfj2SQURVNrryAb38TWx4/Screenshot_2025-10-09_at_11.43.06_AM.png" alt="Shepherd Flow AI Logo" className="h-12 mb-6" data-id="element-23" />
              <p className="text-white/80 mb-6 leading-relaxed" data-id="element-24">
                AI-powered communication platform that helps churches maximize
                their outreach events and create lasting connections.
              </p>
              <div className="flex space-x-4" data-id="element-25">
                <a href="#" className="text-white/80 hover:text-white transition-colors p-2 bg-white/10 rounded-full hover:bg-white/20" data-id="element-26">
                  <FacebookIcon size={18} data-id="element-27" />
                </a>
                <a href="#" className="text-white/80 hover:text-white transition-colors p-2 bg-white/10 rounded-full hover:bg-white/20" data-id="element-28">
                  <TwitterIcon size={18} data-id="element-29" />
                </a>
                <a href="#" className="text-white/80 hover:text-white transition-colors p-2 bg-white/10 rounded-full hover:bg-white/20" data-id="element-30">
                  <InstagramIcon size={18} data-id="element-31" />
                </a>
              </div>
            </div>
            <div data-id="element-32">
              <h3 className="font-semibold text-lg mb-6 flex items-center" data-id="element-33">
                <span className="w-1.5 h-6 bg-[#7091E6] rounded-full mr-2" data-id="element-34"></span>
                Company
              </h3>
              <ul className="space-y-3" data-id="element-35">
                <li data-id="element-36">
                  <a href="#" className="text-white/80 hover:text-white transition-colors flex items-center group" data-id="element-37">
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-38" />
                    About Us
                  </a>
                </li>
                <li data-id="element-39">
                  <a href="#" className="text-white/80 hover:text-white transition-colors flex items-center group" data-id="element-40">
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-41" />
                    Our Team
                  </a>
                </li>
                <li data-id="element-42">
                  <a href="#" className="text-white/80 hover:text-white transition-colors flex items-center group" data-id="element-43">
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-44" />
                    Careers
                  </a>
                </li>
                <li data-id="element-45">
                  <a href="#" className="text-white/80 hover:text-white transition-colors flex items-center group" data-id="element-46">
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-47" />
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-48">
              <h3 className="font-semibold text-lg mb-6 flex items-center" data-id="element-49">
                <span className="w-1.5 h-6 bg-[#7091E6] rounded-full mr-2" data-id="element-50"></span>
                Resources
              </h3>
              <ul className="space-y-3" data-id="element-51">
                <li data-id="element-52">
                  <a href="#" className="text-white/80 hover:text-white transition-colors flex items-center group" data-id="element-53">
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-54" />
                    Blog
                  </a>
                </li>
                <li data-id="element-55">
                  <a href="#" className="text-white/80 hover:text-white transition-colors flex items-center group" data-id="element-56">
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-57" />
                    Help Center
                  </a>
                </li>
                <li data-id="element-58">
                  <a href="#" className="text-white/80 hover:text-white transition-colors flex items-center group" data-id="element-59">
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-60" />
                    Case Studies
                  </a>
                </li>
                <li data-id="element-61">
                  <a href="#" className="text-white/80 hover:text-white transition-colors flex items-center group" data-id="element-62">
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" data-id="element-63" />
                    Webinars
                  </a>
                </li>
              </ul>
            </div>
            <div data-id="element-64">
              <h3 className="font-semibold text-lg mb-6 flex items-center" data-id="element-65">
                <span className="w-1.5 h-6 bg-[#7091E6] rounded-full mr-2" data-id="element-66"></span>
                Contact Us
              </h3>
              <ul className="space-y-4" data-id="element-67">
                <li className="flex items-center gap-3" data-id="element-68">
                  <Mail size={18} className="text-[#7091E6]" data-id="element-69" />
                  <a href="mailto:hello@shepherdflow.ai" className="text-white/80 hover:text-white transition-colors group" data-id="element-70">
                    hello@shepherdflow.ai
                    <span className="block h-0.5 w-0 group-hover:w-full bg-white/30 transition-all duration-300" data-id="element-71"></span>
                  </a>
                </li>
                <li className="flex items-center gap-3" data-id="element-72">
                  <Phone size={18} className="text-[#7091E6]" data-id="element-73" />
                  <a href="tel:+18005551234" className="text-white/80 hover:text-white transition-colors group" data-id="element-74">
                    (800) 555-1234
                    <span className="block h-0.5 w-0 group-hover:w-full bg-white/30 transition-all duration-300" data-id="element-75"></span>
                  </a>
                </li>
              </ul>
              <div className="mt-6 p-4 bg-white/10 rounded-lg" data-id="element-76">
                <p className="text-sm mb-2" data-id="element-77">Subscribe to our newsletter</p>
                <div className="flex" data-id="element-78">
                  <input type="email" placeholder="Your email" className="bg-white/5 border border-white/20 rounded-l-lg px-3 py-2 text-sm flex-1 focus:outline-none focus:ring-1 focus:ring-white/30" data-id="element-79" />
                  <button className="bg-[#7091E6] hover:bg-[#8697C4] px-3 py-2 rounded-r-lg transition-colors" data-id="element-80">
                    <ChevronRight size={16} data-id="element-81" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>
        <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row justify-between items-center" data-id="element-82">
          <div className="text-white/60 text-sm mb-4 md:mb-0" data-id="element-83">
            <p data-id="element-84">&copy; 2025 Shepherd Flow AI. All rights reserved.</p>
          </div>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-85">
            <a href="#" className="text-white/60 text-sm hover:text-white transition-colors" data-id="element-86">
              Privacy Policy
            </a>
            <a href="#" className="text-white/60 text-sm hover:text-white transition-colors" data-id="element-87">
              Terms of Service
            </a>
            <span className="text-white/60 text-sm flex items-center" data-id="element-88">
              Made with <Heart size={12} className="mx-1 text-red-400" data-id="element-89" /> by
              your friends at Text In Church.
            </span>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;